export const RAW_WINDOW_MS=120000, RAW_LIMIT=20000;
export async function loadRawPages(fetchPage,isCurrent=()=>true){
 const found=new Map();let cursor=null;const cursors=new Set();
 do { const page=await fetchPage(cursor);if(!isCurrent())return null;
  for(const sample of page.items)found.set(sample.sample_id,sample);
  if(found.size>RAW_LIMIT)throw Error('ZOOM');
  cursor=page.cursor;
  if(cursor&&cursors.has(cursor))throw Error('CURSOR');
  if(cursor)cursors.add(cursor);
 }while(cursor);
 return [...found.values()];
}
export function rawChart(samples){
 const rows=new Map(),channels=new Map(),segments=[];
 for(const s of new Map(samples.map(s=>[s.sample_id,s])).values()){
  const time=Date.parse(s.timestamp);if(!Number.isFinite(time))continue;
  if(!rows.has(time))rows.set(time,{time,samples:[]});rows.get(time).samples.push(s);
  if(!channels.has(s.channel_id))channels.set(s.channel_id,[]);channels.get(s.channel_id).push(s);
 }
 for(const [channel,list] of channels){let prior=null,segment=null,index=0;
  for(const s of list.sort((a,b)=>Date.parse(a.timestamp)-Date.parse(b.timestamp))){
   const valid=Number.isFinite(s.engineering_value)&&['good','out_of_range'].includes(s.quality);
   const gap=prior&&(s.boot_id!==prior.boot_id||s.config_version!==prior.config_version||s.sample_rate_hz!==prior.sample_rate_hz||Date.parse(s.timestamp)-Date.parse(prior.timestamp)>1500/Math.max(s.sample_rate_hz,.001));
   if(!valid){prior=null;segment=null;continue;}
   if(!segment||gap){segment={key:channel+'_'+index++,channel,count:0};segments.push(segment);}
   rows.get(Date.parse(s.timestamp))[segment.key]=s.engineering_value;segment.count++;prior=s;
  }
 }
 return {rows:[...rows.values()].sort((a,b)=>a.time-b.time),segments};
}
export function overviewChart(points,bucketSeconds,end){
 const rows=new Map();for(const p of points){const time=Date.parse(p.timestamp);
  if(!rows.has(time))rows.set(time,{time,end:Math.min(time+bucketSeconds*1000,end),buckets:[]});const row=rows.get(time);row.buckets.push(p);
  row[p.channel_id+'_range']=p.count?[p.min,p.max]:null;row[p.channel_id+'_max']=p.count?p.max:null;row[p.channel_id+'_avg']=p.count?p.avg:null;
 }return [...rows.values()].sort((a,b)=>a.time-b.time);
}
export function triggerMarkers(events,start,end){
 const latest=new Map();for(const e of events){const old=latest.get(e.event_id);if(!old||e.revision>old.revision)latest.set(e.event_id,e);}
 const unique=new Map();for(const e of [...latest.values()].sort((a,b)=>Boolean(a.continuation_of)-Boolean(b.continuation_of))){if(e.kind==='manual')continue;
  for(const tr of e.triggers||[]){const time=Date.parse(tr.timestamp);if(!Number.isFinite(time)||time<start||time>=end||!Number.isFinite(tr.threshold_bar)||!tr.channel_id)continue;
   const key=[tr.channel_id,tr.timestamp,tr.threshold_bar].join('|');if(!unique.has(key))unique.set(key,{...tr,time,key,event_id:e.event_id,labels:e.labels||[]});
  }
 }return [...unique.values()].sort((a,b)=>a.time-b.time);
}
export function clusterTriggers(markers,start,end,pixelWidth=900){
 const groups=[],width=Math.max(1,pixelWidth),span=Math.max(1,end-start);
 for(const marker of [...markers].sort((a,b)=>a.time-b.time)){
  const last=groups.at(-1),x=(marker.time-start)/span*width;
  if(last&&x-last.lastPixel<60){last.items.push(marker);last.lastPixel=x;last.endTime=marker.time;}
  else groups.push({time:marker.time,endTime:marker.time,lastPixel:x,items:[marker]});
 }
 return groups;
}
